"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import styles from "@/components/nft-image/NFTImage.module.scss";
import { useNftBalanceFromContext } from "@/components/nft-image/NftBalancesContext";
import { useNftBalance } from "@/hooks/useNftBalance";
interface Props {
  readonly contract: string;
  readonly tokenId: number;
  readonly height: 300 | 650 | "full";
}
export default function NFTImageBalance(t0) {
  const $ = _c(21);
  const {
    contract,
    tokenId,
    height
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const consolidationKey = connectedProfile?.consolidation_key ?? null;
  let t1;
  if ($[0] !== consolidationKey || $[1] !== contract || $[2] !== tokenId) {
    t1 = {
      consolidationKey,
      contract,
      tokenId
    };
    $[0] = consolidationKey;
    $[1] = contract;
    $[2] = tokenId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const contextBalance = useNftBalanceFromContext(t1);
  const t2 = !contextBalance;
  let t3;
  if ($[4] !== consolidationKey || $[5] !== contract || $[6] !== t2 || $[7] !== tokenId) {
    t3 = {
      consolidationKey,
      contract,
      tokenId,
      enabled: t2
    };
    $[4] = consolidationKey;
    $[5] = contract;
    $[6] = t2;
    $[7] = tokenId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    balance: nftBalance,
    isLoading,
    error
  } = useNftBalance(t3);
  let t4;
  if ($[9] !== contextBalance || $[10] !== error || $[11] !== isLoading || $[12] !== nftBalance) {
    t4 = contextBalance ?? {
      balance: nftBalance,
      isLoading,
      error
    };
    $[9] = contextBalance;
    $[10] = error;
    $[11] = isLoading;
    $[12] = nftBalance;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const balanceState = t4;
  let t5;
  let t6;
  if ($[14] !== balanceState.balance || $[15] !== balanceState.error || $[16] !== balanceState.isLoading || $[17] !== connectedProfile || $[18] !== height) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const printBalance = () => {
        if (balanceState.balance > 0) {
          return printBalanceSpan(`SEIZED x${balanceState.balance}`);
        } else {
          return printBalanceSpan("UNSEIZED");
        }
      };
      const printBalanceSpan = b => <span className={`${styles.balance} ${height === 650 ? styles.balanceBigger : ""} `}>{b}</span>;
      if (!connectedProfile) {
        t6 = null;
        break bb0;
      }
      if (balanceState.isLoading) {
        t6 = printBalanceSpan("...");
        break bb0;
      }
      if (balanceState.error) {
        console.error("Failed to fetch NFT balance:", balanceState.error);
        t6 = printBalanceSpan("N/A");
        break bb0;
      }
      t5 = printBalance();
    }
    $[14] = balanceState.balance;
    $[15] = balanceState.error;
    $[16] = balanceState.isLoading;
    $[17] = connectedProfile;
    $[18] = height;
    $[19] = t5;
    $[20] = t6;
  } else {
    t5 = $[19];
    t6 = $[20];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  return t5;
}